import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import Carousel from "./carousel"
import "./section-split-image-carousel-v2.scss"

const SectionSplitImageCarouselV2 = ({
  callsToAction,
  slides,
  subHeading,
  text,
  title,
}) => {
  return (
    <section className="section-split-image-carousel-v2">
      <div className="container-v2">
        <div className="section-split-image-carousel-v2--content">
          {title && (
            <h2 className="section-split-image-carousel-v2--title">
              <TextLockupV2>{title}</TextLockupV2>
            </h2>
          )}
          {subHeading?.subTitle && (
            <h3 className="section-split-image-carousel-v2--sub-title">
              {subHeading.subTitle}
            </h3>
          )}
          {text?.childrenMarkdownRemark?.[0]?.html && (
            <div
              className="section-split-image-carousel-v2--text"
              dangerouslySetInnerHTML={{
                __html: text.childrenMarkdownRemark[0].html,
              }}
            />
          )}
          <div className="section-split-image-carousel-v2--cta-buttons under-text-button">
            {callsToAction?.length > 0 &&
              callsToAction?.map(ctaButton => (
                <p
                  className="section-split-image-carousel-v2--cta-button"
                  key={ctaButton.id}
                >
                  <ButtonV2
                    accessibilityLabel={ctaButton.accessibilityLabel}
                    className={getButtonClasses(
                      ctaButton.buttonStyle,
                      ctaButton.buttonSize
                    )}
                    href={ctaButton.path}
                    key={ctaButton.id}
                    showArrow={ctaButton.showArrow === "Yes" ? true : false}
                    text={ctaButton.text}
                  />
                </p>
              ))}
          </div>
        </div>
        {slides && slides?.length > 0 && (
          <Carousel callsToAction={callsToAction} slides={slides} />
        )}
      </div>
    </section>
  )
}
SectionSplitImageCarouselV2.propTypes = {
  callsToAction: PropTypes.arrayOf(
    PropTypes.shape({
      accessibilityLabel: PropTypes.string.isRequired,
      buttonStyle: PropTypes.string.isRequired,
      buttonSize: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      showArrow: PropTypes.bool.isRequired,
      id: PropTypes.string.isRequired,
    })
  ),
  slides: PropTypes.arrayOf(PropTypes.object),
  subHeading: PropTypes.shape({
    subTitle: PropTypes.string.isRequired,
  }).isRequired,
  text: PropTypes.shape({
    childrenMarkdownRemark: PropTypes.arrayOf(
      PropTypes.shape({
        html: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
}

export default SectionSplitImageCarouselV2
